/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-18 17:58:15
 * @modify date 2023-10-18 17:58:15
 * @desc Reion 컴포넌트 에서 사용하는 데이터 정의
 */


import { FONT } from "../../../value/staticValues";
import RegionAdd from "./RegionAdd";
import RegionUpdate from "./RegionUpdate";
import i18n from "../../../lang/base";
import { ListActionMenu, ListFilter, ListTableHeader } from "../../base/table/listTableType";
import { TABLE_ACTION_MENU_TYPE, TABLE_BUTTON_TYPE } from "../../../value/type";
import { ReactComponent as AddButtonImg } from "../../../img/ico-prefix-add.svg";
import { ReactComponent as AddButtonActiveImg } from "../../../img/ico-prefix-add-white.svg";
import { parseLocaleDatetime } from "common/util";


export interface RegionData {
    region_id: string,
    region_name: string,
    region_description: string,
    create_ts: string,
    update_ts: string,
    host_count: number,
    storage_pool_count: number
}


export const actionMenus:ListActionMenu[] = [
    {
        id: 1,
        name: i18n.t("SYNC_TEXT"),
        type: TABLE_ACTION_MENU_TYPE.PUSH_BUTTON,
        activeYn: true,
        button: {
            type: TABLE_BUTTON_TYPE.PUSH,
            code: "REGION_SYNC",
        }
    },
];



export const tableHeaders:ListTableHeader[] = [
    {
        Header: i18n.t("REGION_NAME_TEXT"),
        accessor: "region_name",
        disableSortBy: false,
        style: {
            width: "150px",
        },
        Cell: ({ cell: {value} }) => (<div style={className.nameTextContainer}>{value}</div>)
    },
    {
        Header: i18n.t("REGION_HOST_COUNT_TEXT"),
        accessor: "host_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.greenText}}>{value}{i18n.t("UNIT_TEXT")}</div>
        )
    },
    {
        Header: i18n.t("REGION_STROAGE_POOL_COUNT_TEXT"),
        accessor: "storage_pool_count",
        disableSortBy: true,
        style: {
            width: "80px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.blueText}}>{value}{i18n.t("UNIT_TEXT")}</div>
        )
    },
    {
        Header: i18n.t("UPDATE_DATE_TEXT"),
        accessor: "update_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={className.normalTextContainer}>
                {value ? parseLocaleDatetime(value) : ""}
            </div>
        )
    },
    {
        Header: i18n.t("CREATE_DATE_TEXT"),
        accessor: "create_ts",
        disableSortBy: false,
        style: {
            width: "120px",
        },
        Cell: ({ cell: {value} }) => (
            <div style={{...className.normalTextContainer, ...className.dateContainer}}>
                {value ? parseLocaleDatetime(value)  : ""}
            </div>
        )
    },
];


export const regionAddModalContent = {
    title: i18n.t("REGION_CREATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("CREATE_TEXT")
        },
    ],
    innerComponent: <RegionAdd />,
}


export const regionUpdateModalContent = {
    title: i18n.t("REGION_UPDATE_TEXT"),
    stepCount: 1,
    footerButtons: [
        {
            index: 0,
            prevButtonYn: false,
            cancelButtonYn: true,
            confirmButtonText: i18n.t("UPDATE_SAVE_TEXT")
        },
    ],
    innerComponent: <RegionUpdate />,
}


const className = {
    statusContainer: {
        width: 56,
        display: "flex", Jusitipy: "center", justifyContent: "center",
        borderRadius: 10,
        backgroundColor: "#b6bfce",
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#fff"
    },
    nameTextContainer: {
        fontFamily: FONT.MEDIUM,
        fontSize: 14,
        color: "#333",
        overflow: "hidden"
    },
    normalTextContainer: {
        fontFamily: FONT.REGULAR,
        fontSize: 12,
        color: "#333",
        overflow: "hidden"
    },
    dateContainer: {
        color: "#9ea0a5",
    },
    blueContainer: {
        color: "#0853fb"
    },
    countContainer: {
        color: "#3a8344"
    },
    purpleText: {
        color: "#7066f1"
    },
    blueText: {
        color: "#0853fb"
    },
    greenText: {
        color: "#3a8344"
    },
    statusImg: {
        marginRight: 3
    },
}